/**
 * What search engines see of each route.
 *
 * The SPA serves the same index.html for every URL, so without this every page
 * shared one title and one description, none had a canonical, and an unknown
 * URL answered 200 with the landing. Only the public pages below go to Google;
 * any other route (login, signup, the panel, admin) gets noindex and no canonical.
 *
 * public/sitemap.xml lists exactly these paths: change both together
 * (src/__tests__/seo.test.ts fails if they drift).
 */
export const SITE_URL = 'https://offices.immigrantshield.com'

export const INDEXED_PAGES = {
  '/': 'landing',
  '/about': 'about',
  '/faq': 'faq',
  '/support': 'support',
  '/legal': 'legal',
  '/plans': 'plans',
} as const

export type SeoPage = (typeof INDEXED_PAGES)[keyof typeof INDEXED_PAGES]

export function seoPageFor(pathname: string): SeoPage | null {
  return (INDEXED_PAGES as Record<string, SeoPage>)[pathname] ?? null
}

/** Canonical URL of an indexed page: no query string, no trailing slash except the root. */
export function canonicalUrl(pathname: string): string {
  return SITE_URL + pathname
}

export function setMetaTag(attr: 'name' | 'property', key: string, content: string | null) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (content === null) {
    el?.remove()
    return
  }
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

export function setCanonical(href: string | null) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (href === null) {
    el?.remove()
    return
  }
  if (!el) {
    el = document.createElement('link')
    el.rel = 'canonical'
    document.head.appendChild(el)
  }
  el.href = href
}
